<app-header></app-header>

<main>
  <router-outlet></router-outlet>
</main>

<app-lgpd-popup></app-lgpd-popup>
